import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchColors,
  createColor,
  // fetchColor,
  // modifyColor,
  // deleteColor,
} from "../../api/colorApi";

export const getColors = createAsyncThunk(
  "colors/getColors",
  async ({ organization_id, token, page, limit }) => {
    const response = await fetchColors({ organization_id, page, limit, token });
    return response; // must return { data: [...], total_records, success, message }
  }
);

export const addColors = createAsyncThunk(
  "colors/addColors",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createColor(formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// export const getColorsDetails = createAsyncThunk(
//   "colors/getColorsDetails",
//   async (colorId, { rejectWithValue }) => {
//     try {
//       const response = await fetchColor(colorId);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// export const updateColors = createAsyncThunk(
//   "colors/updateColors",
//   async ({ id, ...payload }, { rejectWithValue }) => {
//     try {
//       const response = await modifyColor(id, payload);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// export const deleteColors = createAsyncThunk(
//   "colors/deleteColors",
//   async (colorId, { rejectWithValue }) => {
//     try {
//       const response = await deleteColor(colorId);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

const colorSlice = createSlice({
  name: "colors",
  initialState: {
    colors: {
      data: [],
      total_records: 0,
      url: null,
    },
    colorDetails: null,
    isLoading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getColors.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getColors.fulfilled, (state, action) => {
        state.isLoading = false;
        state.colors = action.payload;
      })
      .addCase(getColors.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(addColors.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addColors.fulfilled, (state, action) => {
        state.isLoading = false;
        state.successMessage = action.payload.message;
        if (action.payload.data) {
          state.colors = action.payload;
        }
      })
      .addCase(addColors.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // .addCase(getColorsDetails.pending, (state) => {
    //   state.isLoading = true;
    //   state.error = null;
    // })
    // .addCase(getColorsDetails.fulfilled, (state, action) => {
    //   state.isLoading = false;
    //   state.colorDetails = action.payload;
    // })
    // .addCase(getColorsDetails.rejected, (state, action) => {
    //   state.isLoading = false;
    //   state.error = action.payload;
    // })

    // .addCase(updateColors.pending, (state) => {
    //   state.isLoading = true;
    //   state.error = null;
    // })
    // .addCase(updateColors.fulfilled, (state, action) => {
    //   state.isLoading = false;
    //   state.successMessage = action.payload.message;
    // })
    // .addCase(updateColors.rejected, (state, action) => {
    //   state.isLoading = false;
    //   state.error = action.payload;
    // })

    // .addCase(deleteColors.pending, (state) => {
    //   state.isLoading = true;
    //   state.error = null;
    // })
    // .addCase(deleteColors.fulfilled, (state, action) => {
    //   state.isLoading = false;
    //   state.successMessage = action.payload.message;
    // })
    // .addCase(deleteColors.rejected, (state, action) => {
    //   state.isLoading = false;
    //   state.error = action.payload;
    // });
  },
});

export const { clearMessages } = colorSlice.actions;

export default colorSlice.reducer;
